<template>
  <div>
    <div v-if="productType !== 'Pillows'">
      <ProductSizeDisplay
        :active-product="activeProduct"
        :product-type="productType"
      />
    </div>
    <div class="product-expand">
      <Transition name="fade">
        <div v-if="!isFrame" class="card-expand card-animation">
          <div class="block-variant-img">
            <img
              v-if="activeProduct.image"
              :src="activeProduct.image"
              :alt="handleProductAlt('IMAGE')"
              class="box-image-0"
            />
            <div v-else class="box-image-0 missing-image">
              {{ handleProductAlt("IMAGE") }}
            </div>
          </div>
        </div>
      
        <div v-else class="card-expand card-drawing">
          <div class="block-variant-img">
            <img
              v-if="activeProduct.frame"
              :src="activeProduct.frame"
              :alt="handleProductAlt('FRAME')"
              class="box-image"
            />
            <div v-else class="box-image missing-image">
              {{ handleProductAlt("FRAME") }}
            </div>
          </div>
        </div>
      </Transition>
    </div>

    <div v-if="productType == 'Pillows'">
      <div class="pillow-copy">
        Includes premium down alternative insert. 
      </div>
      <div class="pillow-selector__container">
        <div 
          class="pillow-selector__select"
          v-for="(pillow) in pillows"
          :class="{ 'active-select': pillow === activeItem}"
          :key="pillow"
          @click="selectItem(pillow)"
        >
          <input  
            type="radio" 
            :id="pillow"
            :value="pillow"
            v-model="checkedSize"
            @change="handleOptionChanged($event.target.value, 'pillow_size')"
          >
          <label :for="pillow">
            <span class="checkmark" :class="{ active: pillow === activeItem}"></span>
            {{ pillow }}
          </label>
        </div>
      </div>
    </div>
    <div v-if="canToggle" class="checkbox-wrapper">
      <div class="checkbox">
        <label for="show_dimensions">
          Show Dimensions
          <div class="custom-checkbox" :class="{active: isFrame}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="" stroke-linejoin="" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>
          <input
            id="show_dimensions"
            name="show_dimensions"
            type="checkbox"
            v-model="isFrame"
            style="display:none!important;"
          />
          </label>
      </div>
    </div>
    <div>
      <div
        v-if="
          ['Sofa', 'Chair', 'Loveseat', 'Sofa with Bumper', 'Corner'].includes(
            productType
          )
        "
      >
        <ProductRangeSlider
          v-if="firstWidth.length > 1"
          :options="firstWidth"
          :default-val="activeProduct.width_1"
          @range-value-changed="handleOptionChanged($event, 'width_1')"
          @slider-updated="$emit('selector-content-updated')"
        />
      </div>
      <div v-else-if="'Sectional' === productType">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="firstWidth.length > 1"
            class="half-width"
            :options="firstWidth"
            label="Sofa Side"
            :default-val="activeProduct.width_1"
            @range-value-changed="handleOptionChanged($event, 'width_1')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="secondWidth.length > 1"
            :options="secondWidth"
            class="half-width"
            label="Corner Piece"
            :default-val="activeProduct.width_2"
            @range-value-changed="handleOptionChanged($event, 'width_2')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="'Sectional with Bumper' === productType">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="firstWidth.length > 1"
            class="half-width"
            :options="firstWidth"
            label="Sofa Side"
            :default-val="activeProduct.width_1"
            @range-value-changed="handleOptionChanged($event, 'width_1')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="secondWidth.length > 1"
            :options="secondWidth"
            class="half-width"
            label="Bumper Piece"
            :default-val="activeProduct.width_2"
            @range-value-changed="handleOptionChanged($event, 'width_2')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="productType === 'Chaise'">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="chaiseWidth.length > 1"
            :options="chaiseWidth"
            class="half-width"
            :default-val="activeProduct.chaise_width"
            :key="chaiseWidth.join('|')"
            @range-value-changed="handleOptionChanged($event, 'chaise_width')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseLength.length > 1"
            :options="chaiseLength"
            class="half-width"
            :default-val="activeProduct.chaise_length"
            :key="chaiseLength.join('|')"
            @range-value-changed="handleOptionChanged($event, 'chaise_length')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="productType === 'Desk'">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="firstWidth.length > 1"
            :options="firstWidth"
            class="half-width"
            label="Width"
            :default-val="activeProduct.width_1"
            @range-value-changed="handleOptionChanged($event, 'width_1')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="depths.length > 1"
            :options="depths"
            class="half-width"
            label="Depth"
            :default-val="activeProduct.depth_size"
            @range-value-changed="handleOptionChanged($event, 'depth_size')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="productType === 'Sofa with Chaise'">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="firstWidth.length > 1"
            class="half-width"
            :options="firstWidth"
            label="Overall Width"
            :default-val="activeProduct.width_1"
            :key="firstWidth.join('|')"
            @range-value-changed="handleOptionChanged($event, 'width_1')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseWidth.length > 1"
            :options="chaiseWidth"
            class="half-width"
            label="Chaise Width"
            :default-val="activeProduct.chaise_width"
            :key="chaiseWidth.join('|')"
            @range-value-changed="handleOptionChanged($event, 'chaise_width')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseLength.length > 1"
            :options="chaiseLength"
            class="half-width"
            label="Chaise Length"
            :default-val="activeProduct.chaise_length"
            :key="chaiseLength.join('|')"
            @range-value-changed="handleOptionChanged($event, 'chaise_length')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="['Double Chaise Sectional'].includes(productType)">
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="secondWidth.length > 1"
            class="half-width"
            :options="secondWidth"
            label="Overall Width"
            :default-val="activeProduct.width_2"
            @range-value-changed="handleOptionChanged($event, 'width_2')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseWidth.length > 1"
            :options="chaiseWidth"
            class="half-width"
            label="Chaise Width"
            :default-val="activeProduct.chaise_width"
            @range-value-changed="handleOptionChanged($event, 'chaise_width')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseLength.length > 1"
            :options="chaiseLength"
            class="half-width"
            label="Chaise Length"
            :default-val="activeProduct.chaise_length"
            @range-value-changed="handleOptionChanged($event, 'chaise_length')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="['U-Shaped Sectional With Chaise','Sectional With Chaise'].includes(productType)">
        <!-- NOTE the sync has value firelds dependant on orienation -->
        <div class="options--triple-range">
          <template v-if="activeProduct.orientation === 'Chaise On Right'">
            <ProductRangeSlider
              v-if="secondWidth.length > 1"
              class="half-width"
              :options="secondWidth"
              label="Total Width"
              :default-val="activeProduct.width_2"
              @range-value-changed="handleOptionChanged($event, 'width_2')"
              @slider-updated="$emit('selector-content-updated')"
            />
            <ProductRangeSlider
              v-if="firstWidth.length > 1"
              :options="firstWidth"
              class="half-width"
              label="Corner Side Length"
              :default-val="activeProduct.width_1"
              @range-value-changed="handleOptionChanged($event, 'width_1')"
              @slider-updated="$emit('selector-content-updated')"
            />
          </template>
          <template v-else>
            <ProductRangeSlider
              v-if="secondWidth.length > 1"
              class="half-width"
              :options="secondWidth"
              label="Total Width"
              :default-val="activeProduct.width_2"
              @range-value-changed="handleOptionChanged($event, 'width_2')"
              @slider-updated="$emit('selector-content-updated')"
            />
            <ProductRangeSlider
              v-if="thirdWidth.length > 1"
              :options="thirdWidth"
              class="half-width"
              label="Corner Side Length"
              :default-val="activeProduct.width_3"
              @range-value-changed="handleOptionChanged($event, 'width_3')"
              @slider-updated="$emit('selector-content-updated')"
            />
          </template>
          <!-- NOTE these are not currently used in the system -->
          <ProductRangeSlider
            v-if="chaiseWidth.length > 1"
            :options="chaiseWidth"
            class="half-width"
            label="Chaise Width"
            :default-val="activeProduct.chaise_width"
            @range-value-changed="handleOptionChanged($event, 'chaise_width')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="chaiseLength.length > 1"
            :options="chaiseLength"
            class="half-width"
            label="Chaise Length"
            :default-val="activeProduct.chaise_length"
            @range-value-changed="handleOptionChanged($event, 'chaise_length')"
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div
        v-else-if="
          ['U-Shaped Sectional', 'U-Shaped Sectional With Bumpers'].includes(
            productType
          )
        "
      >
        <div class="options--triple-range">
          <ProductRangeSlider
            v-if="secondWidth.length > 1"
            class="half-width"
            :options="secondWidth"
            label="Overall Width"
            :default-val="activeProduct.width_2"
            :key="secondWidth.join('|')"
            @range-value-changed="handleOptionChanged($event, 'width_2')"
            @slider-updated="$emit('selector-content-updated')"
          />
          <ProductRangeSlider
            v-if="uShapedLengths.length > 1"
            :options="uShapedLengths.map((option) => option.width_1)"
            class="half-width"
            label="Right/Left Side"
            :default-val="activeProduct.width_1"
            :key="uShapedLengths.map((option) => option.width_1).join('|')"
            @range-value-changed="
              handleCombinationChanged($event, 'width_1', uShapedLengths)
            "
            @slider-updated="$emit('selector-content-updated')"
          />
        </div>
      </div>
      <div v-else-if="productType === 'Sofa Bed'">
        <ProductRangeSlider
          v-if="sofaBedOptions.length > 1"
          :options="sofaBedOptions.map((option) => option.width_1)"
          :default-val="activeProduct.width_1"
          @range-value-changed="
            handleCombinationChanged($event, 'width_1', sofaBedOptions)
          "
          @slider-updated="$emit('selector-content-updated')"
        />
      </div>
      <ProductRadioButtons
        v-if="ottomanSizes.length > 1 && productType === 'Ottoman'"
        :default-val="getCombinationActiveProduct('width_1', 'depth_size')"
        :options="ottomanSizes"
        :product-type="productType"
        @radio-value-changed="handleOptionChanged($event, 'ottoman-size')"
        @radio-updated="$emit('selector-content-updated')"
      />
      <ProductRadioButtons
        v-if="drawers.length > 1"
        :default-val="activeProduct.drawer"
        :options="drawers"
        @radio-value-changed="handleOptionChanged($event, 'drawer')"
        @radio-updated="$emit('selector-content-updated')"
      />
      <ProductRadioButtons
        v-if="orientation.length > 1"
        :default-val="activeProduct.orientation"
        :options="orientation"
        @radio-value-changed="handleOptionChanged($event, 'orientation')"
        @radio-updated="$emit('selector-content-updated')"
      />
      <!-- NOTE these headings should only show if frame sizes and headboard heights present -->
      <div 
      v-if="bedSizes.length > 1 && headboardHeights.length > 1 && productType !== 'Sofa Bed'"
        class="option-heading"
      >
        Frame Size
      </div>
      <ProductRadioButtons
        v-if="bedSizes.length > 1 && productType !== 'Sofa Bed'"
        :default-val="activeProduct.bed_size"
        :options="bedSizes"
        @radio-value-changed="handleOptionChanged($event, 'bed_size')"
        @radio-updated="$emit('selector-content-updated')"
      />
      <!-- NOTE these headings should only show if frame sizes and headboard heights present -->
      <div
        v-if="bedSizes.length > 1 && headboardHeights.length > 1 && productType !== 'Sofa Bed'"
        class="option-heading"
      >
        Headboard Height
      </div>
      <ProductRadioButtons
        v-if="headboardHeights.length > 1 && productType !== 'Sofa Bed'"
        :default-val="activeProduct.headboard_height"
        :options="headboardHeights"
        @radio-value-changed="handleOptionChanged($event, 'headboard_height')"
        @radio-updated="$emit('selector-content-updated')"
      />
      <ProductOptionButtons
        v-if="depthCombinations.length > 1"
        label="Depth"
        :default-val="activeProduct.depth"
        :options="depthCombinations"
        @button-value-changed="handleOptionChanged($event, 'depth')"
        @options-updated="$emit('selector-content-updated')"
      />
    </div>
    <!-- <div class="shipping_length">
      {{ shippingString }}
    </div> -->
    <div v-if="!isPrintout && !hideCall" class="kicker-section">
      <span>Need Help Deciding?</span>
      <a :href="`${currentURL}&view=printout`">Order A Free Printout</a>
    </div>
  </div>
</template>
<script>
// import AppImage from "./AppImage.vue";
import ProductRangeSlider from "./ProductRangeSlider.vue";
import ProductRadioButtons from "./ProductRadioButtons.vue";
import ProductOptionButtons from "./ProductOptionButtons.vue";
import ProductSizeDisplay from "./ProductSizeDisplay.vue";
export default {
  name: "ProductImageSelector",
  components: {
    ProductRangeSlider,
    ProductRadioButtons,
    ProductOptionButtons,
    ProductSizeDisplay
    // AppImage,
  },
  props: {
    activeProduct: Object,
    defaultProduct: Object,
    selectedProduct: Object,
    products: Array,
    productType: String,
    isPrintout: Boolean,
    hideCall: Boolean,
    shipping: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
      firstWidth: this.activeProduct["width_1"]
        ? this.getFilteredOptions(["width_1"], ["width_1"])
        : [],
      secondWidth: this.activeProduct["width_2"]
        ? this.getFilteredOptions(["width_2"], ["width_2"])
        : [],
      thirdWidth: this.activeProduct["width_3"]
        ? this.getFilteredOptions(["width_3"], ["width_3"])
        : [],
      chaiseWidth: this.activeProduct["chaise_width"]
        ? this.getFilteredOptions(["chaise_width", "width_2"], ["chaise_width"])
        : [],
      chaiseLength: this.activeProduct["chaise_length"]
        ? this.getFilteredOptions(["chaise_length"], ["chaise_length"])
        : [],
      orientation: this.activeProduct["orientation"]
        ? // Widths need to be ignored to handle the u-shaped sectional with chaise
          this.getFilteredOptions(
            ["orientation", "width_1", "width_2", "width_3"],
            ["orientation"]
          )
        : [],
      depthCombinations:
        this.activeProduct["depth"] && this.activeProduct["depth_size"]
          ? this.deriveCombinationOptions("depth", "depth_size", '"')
          : [],
      ottomanSizes:
        this.activeProduct["width_1"] && this.activeProduct["depth_size"]
          ? this.deriveSizeCombinationOptions("width_1", "depth_size", true)
          : [],
      bedSizes: this.activeProduct["bed_size"]
        ? this.sortBeds(this.deriveOptions("bed_size"))
        : [],
      depths: this.activeProduct["depth_size"]
        ? this.deriveOptions("depth_size")
        : [],
      headboardHeights: this.activeProduct["headboard_height"]
        ? this.deriveOptions("headboard_height").sort()
        : [],
      drawers: this.activeProduct["drawer"] ? this.deriveOptions("drawer") : [],
      isFrame: this.setDefaultIsFrame(),
      canToggle: this.isTogglableProduct(),
      optionsObject: this.getOptionsToCheck(),
      sofaBedOptions:
        this.activeProduct["width_1"] && this.activeProduct["bed_size"]
          ? this.deriveSizeCombinationOptions("width_1", "bed_size")
          : [],
      uShapedLengths:
        this.activeProduct["width_1"] && this.activeProduct["width_3"]
          ? this.deriveSizeCombinationOptions("width_1", "width_3")
          : [],
      checkedSize: this.activeProduct["pillow_size"] ? this.activeProduct["pillow_size"] : "",
      activeItem: this.activeProduct["pillow_size"] ? this.activeProduct["pillow_size"] : null,
      pillows: this.activeProduct["pillow_size"] ? this.deriveOptions("pillow_size").sort() : [],
    };
  },
  computed: {
    currentURL() {
      return window.location.href
    }
  },
  mounted() {},
  watch: {
    activeProduct(newValue) {
      this.firstWidth = this.activeProduct["width_1"]
        ? this.getFilteredOptions(["width_1"], ["width_1"], newValue)
        : [];
      this.secondWidth = this.activeProduct["width_2"]
        ? this.getFilteredOptions(["width_2"], ["width_2"], newValue)
        : [];
      this.thirdWidth = this.activeProduct["width_3"]
        ? this.getFilteredOptions(["width_3"], ["width_3"], newValue)
        : [];
      this.chaiseWidth = this.activeProduct["chaise_width"]
        ? this.getFilteredOptions(
            ["chaise_width", "width_2"],
            ["chaise_width"],
            newValue
          )
        : [];
      this.chaiseLength = this.activeProduct["chaise_length"]
        ? this.getFilteredOptions(
            ["chaise_length"],
            ["chaise_length"],
            newValue
          )
        : [];
      this.orientation = this.activeProduct["orientation"]
        ? // Widths need to be ignored to handle the u-shaped sectional with chaise
          this.getFilteredOptions(
            ["orientation", "width_1", "width_2", "width_3"],
            ["orientation"]
          )
        : [];
      this.pillows = this.activeProduct["pillow_size"] 
        ? 
          this.deriveOptions("pillow_size").sort()
        : [];
    },
  },
  methods: {
    selectItem(pillow) {
      this.activeItem = pillow;
    },
    handleCombinationChanged(newValue, valueToMatch, options) {
      const matchingOption = options.find(
        (option) => option[valueToMatch] === newValue
      );
      if (matchingOption) {
        const optionAsArray = [];
        Object.keys(matchingOption).forEach((key) => {
          const optionObject = {
            option: key,
            value: matchingOption[key],
          };
          optionAsArray.push(optionObject);
        });
        this.$emit("option-changed", optionAsArray);
      }
    },
    sortBeds(bedOptions) {
      const bedOrder = ["Twin", "Full", "Queen", "King", "Cal King"];
      const sortedOptions = [];
      if (bedOptions.length > 0) {
        bedOrder.forEach((option) => {
          if (bedOptions.includes(option)) {
            sortedOptions.push(option);
          }
        });
        return sortedOptions;
      }
      return bedOptions;
    },
    getFilteredOptions(valuesToIgnore, valuesToGet = [], productToBase) {
      let filteredProducts = this.products.filter((product) =>
        this.productFilterFunction(
          product,
          [...valuesToIgnore],
          this.getOptionsToCheck(productToBase)
        )
      );

      if (valuesToGet.length > 0) {
        if (valuesToGet.length > 1) {
          filteredProducts = filteredProducts.map((product) => {
            const mappingObject = {};
            valuesToGet.forEach(
              (value) => (mappingObject[value] = product[value])
            );
            return mappingObject;
          });
        } else {
          filteredProducts = filteredProducts.map(
            (product) => product[valuesToGet[0]]
          );
          filteredProducts.sort((firstVal, secondVal) =>
            firstVal < secondVal ? 1 : -1
          );
        }
      }
      return [...new Set(filteredProducts)];
    },
    productFilterFunction(product, valuesToIgnore, optionsObject) {
      const optionsToCheck = Object.assign({}, optionsObject);
      for (const value of valuesToIgnore) {
        delete optionsToCheck[value];
      }
      for (const key in optionsToCheck) {
        const desiredValue = optionsToCheck[key];
        const productValue = product[key];
        if (productValue !== desiredValue) return false;
      }
      return true;
    },
    getOptionsToCheck(baseObject) {
      const possibleOptions = [
        "width_1",
        "width_2",
        "width_3",
        "pillow_size",
        "chaise_width",
        "chaise_length",
        "orientation",
        "depth",
        "depth_size",
      ];
      const optionsObject = {};
      if (!baseObject) {
        const searchParams = new URLSearchParams(window.location.search);
        possibleOptions.forEach((option) => {
          if (searchParams.has(option)) {
            optionsObject[option] = searchParams.get(option);
          }
        });
      } else {
        possibleOptions.forEach((option) => {
          if (baseObject[option]) {
            optionsObject[option] = baseObject[option];
          }
        });
      }
      return optionsObject;
    },
    setDefaultIsFrame() {
      const defaultFrameProducts = [
        "Chair",
        "Desk",
        "Sofa Bed",
        "Modular Piece",
        "Modular Sectional",
      ];
      // Check if this is an extra deep sectional
      const extraDeepSplitProducts = ["Sectional", "Sectional with Bumper"];
      if (
        extraDeepSplitProducts.includes(this.productType) &&
        this.activeProduct.depth === "Extra Deep"
      ) {
        return true;
      }
      return defaultFrameProducts.includes(this.productType);
    },
    isTogglableProduct() {
      const togglableProducts = [
        "Sofa with Chaise",
        "Chaise",
        "Loveseat",
        "Ottoman",
        "Sofa",
        "Sofa with Bumper",
        "Sectional",
        "Sectional with Bumper",
        "Double Chaise Sectional",
        "U-Shaped Sectional",
        "U-Shaped Sectional With Bumpers",
        "U-Shaped Sectional With Chaise",
        "Sectional With Chaise",
        "Pillow"
      ];
      // Check if this is an extra deep sectional
      const extraDeepSplitProducts = ["Sectional", "Sectional with Bumper"];
      if (
        extraDeepSplitProducts.includes(this.productType) &&
        this.activeProduct.depth === "Extra Deep"
      ) {
        return false;
      }
      return togglableProducts.includes(this.productType);
    },
    handleProductAlt(image_type) {
      if (image_type === "IMAGE") {
        if (!this.activeProduct.image) {
          return "Sorry, image not available for this product";
        }
        return `${this.activeProduct.sku} Image`;
      } else {
        if (!this.activeProduct.frame) {
          return "Sorry, map view not available for this product";
        }
        return `${this.activeProduct.sku} Frame`;
      }
    },
    handleOptionChanged(value, option) {
      let options = [{ option, value }];
      if (typeof value === "object") {
        options = this.processCombinationValue(option, value);
      }
      if (this.productType === "Double Chaise Sectional") {
        if (this.activeProduct.depth && typeof value !== "object") {
          options.push({ option: "depth", value: this.activeProduct.depth });
        }
        options = options.concat(this.checkForNewDefaults(options));
      } else if (
        option === "orientation" &&
        (this.productType === "U-Shaped Sectional With Chaise" || this.productType === "Sectional With Chaise")
      ) {
        // Depth is being forced to limit the options
        options.push(
          { option: "depth", value: this.activeProduct.depth },
          { option: "depth_size", value: this.activeProduct.depth_size }
        );

        options = options.concat(this.checkForNewDefaults(options));
      }
      this.optionsObject = this.getOptionsToCheck();
      this.$emit("option-changed", options);
    },
    processCombinationValue(option, value) {
      if (option === "depth") {
        const depthSize = value.detail.replaceAll(/[\\]|["]/g, "");
        let values = [
          {
            option: "depth",
            value: value.text,
          },
          {
            option: "depth_size",
            value: depthSize,
          },
        ];
        // NOTE this is a hack because some of the double chaise sectionals have everything driving everything
        values = values.concat(this.checkForNewDefaults(values, true));
        return values;
      }
      if (option === "ottoman-size") {
        const values = [];
        Object.keys(value).forEach((key) => {
          values.push({
            option: key,
            value: value[key],
          });
        });
        return values;
      }
      return [{ option, value }];
    },
    checkForNewDefaults(changingValues, isDepth = false) {
      let newDefaults = [];
      const objectToFind = {};
      changingValues.forEach((value) => {
        objectToFind[value.option] = value.value;
      });
      // Ensuring that orientation is aways accounted for
      if (!objectToFind["orientation"] && this.activeProduct.orientation) {
        objectToFind["orientation"] = this.activeProduct.orientation;
      }
      const newMatches = this.products.filter((product) => {
        let completeMatch = true;
        for (const key of Object.keys(objectToFind)) {
          if (product[key] != objectToFind[key]) {
            completeMatch = false;
          }
        }
        return completeMatch;
      });

      // Need to flag the key that we will block in the new defaults
      let keyToBlock = "";
      if (this.productType === "U-Shaped Sectional With Chaise" || this.productType === "Sectional With Chaise") {
        if (objectToFind["orientation"] === "Chaise On Right") {
          keyToBlock = "width_3";
        } else {
          keyToBlock = "width_1";
        }
      }
      if (newMatches.length > 1) {
        const baseValues = this.sortOnProductSpecificBaseValues(
          newMatches,
          isDepth
        );
        Object.keys(baseValues).forEach((key) => {
          const value = key === keyToBlock ? undefined : baseValues[key];
          newDefaults.push({
            option: key,
            value: value,
          });
        });
      }
      return newDefaults;
    },
    deriveOptions(option) {
      const options = [];
      this.products.forEach((product) => {
        if (product[option] && !options.includes(product[option])) {
          options.push(product[option]);
        }
      });
      return options;
    },
    getCombinationActiveProduct(firstOption, secondOption) {
      const optionObject = {};
      optionObject[firstOption] = this.activeProduct[firstOption];
      optionObject[secondOption] = this.activeProduct[secondOption];
      return optionObject;
    },
    deriveSizeCombinationOptions(
      firstOption,
      secondOption,
      sortOnFirst = true
    ) {
      const options = [];
      this.products.forEach((product) => {
        if (product[firstOption] && product[secondOption]) {
          const optionObject = {};
          optionObject[firstOption] = product[firstOption];
          optionObject[secondOption] = product[secondOption];
          options.push(optionObject);
        }
      });
      const result = [];
      const map = new Map();
      for (const item of options) {
        const optionString = item[firstOption] + " " + item[secondOption];
        if (!map.has(optionString)) {
          map.set(optionString, true); // set any value to Map
          result.push(item);
        }
      }
      result.sort((a, b) => {
        if (sortOnFirst) return a[firstOption] < b[firstOption] ? -1 : 1;
        return a[secondOption] > b[secondOption] ? -1 : 1;
      });
      return result;
    },
    deriveCombinationOptions(
      firstOption,
      secondOption,
      secondaryDelimiter = ""
    ) {
      const options = [];
      this.products.forEach((product) => {
        if (product[firstOption] && product[secondOption]) {
          options.push({
            text: product[firstOption],
            detail: product[secondOption] + secondaryDelimiter,
          });
        }
      });
      const result = [];
      const map = new Map();
      for (const item of options) {
        if (!map.has(item.text)) {
          map.set(item.text, true); // set any value to Map
          result.push({
            text: item.text,
            detail: item.detail,
          });
        }
      }
      result.sort((a, b) => (a.detail > b.detail ? 1 : -1));
      return result;
    },
    sortOnProductSpecificBaseValues(options, isDepth = false) {
      const optionMapping = this.getProductOptionMapping(isDepth);
      options.forEach((option) => {
        Object.keys(optionMapping).forEach((key) => {
          if (option[key]) {
            if (optionMapping[key] === 0) {
              optionMapping[key] = parseInt(option[key]);
            } else if (parseInt(option[key]) <= optionMapping[key]) {
              optionMapping[key] = parseInt(option[key]);
            }
          }
        });
      });
      return optionMapping;
    },
    getProductOptionMapping(forceLength = false) {
      // NOTE this may be susceptible to needing manual changes but this is the result of how the sync is structed
      // These are used to set the values that can change with the options selected
      switch (this.productType) {
        case "Chaise":
          return {
            chaise_width: 0,
            chaise_length: 0,
          };
        case "Sofa with Chaise":
          return {
            width_1: 0,
            chaise_width: 0,
            chaise_length: 0,
          };
        case "U-Shaped Sectional With Bumpers":
        case "U-Shaped Sectional":
          return {
            width_1: 0,
            width_2: 0,
            width_3: 0,
          };
        case "Double Chaise Sectional":
          if (forceLength) {
            return {
              width_2: 0,
              chaise_width: 0,
              chaise_length: 0,
            };
          }
          return {
            width_2: 0,
            chaise_width: 0,
            // chaise_length: 0,
          };
        case "U-Shaped Sectional With Chaise":
        case "Sectional With Chaise":
          return {
            width_1: 0,
            width_2: 0,
            width_3: 0,
            chaise_width: 0,
            chaise_length: 0,
          };
        default:
          return {};
      }
    },
  },
};
</script>
<style scoped>
.kicker-section {
 font-size: 16px; 
 font-weight: 400;
 color: #393534;
 display: flex;
 justify-content: center;
 gap: 12px;
 margin-top: 20px;
 flex-wrap: wrap;
}
.kicker-section a,.kicker-section a:visited {
  color: #393534!important;
}
.checkbox-wrapper {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
}
.checkbox-wrapper label {
  display: flex;
  gap: 12px;
  align-items: center;
}
.custom-checkbox {
  background: #F0F0F0;
  border: 0.8px solid #393534;
  height: 17px;
  width: 17px;
  display: flex;
  align-items:center;
  justify-content: center;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}
.custom-checkbox svg {
  height: 100%;
  width: 100%;
  transition: 0.3s ease-in-out;
  opacity: 0;
}
.custom-checkbox.active svg {
  opacity: 1;
}

.shipping_length {
  font-weight: 600;
  margin: 15px 0 5px;
  font-size: 14px;
  padding: 10px 20px;
  border: 1px solid #cbc8c3;
  background-color: #f2f2f2;
  border-radius: 10px;
  display: inline-block;
}
/* .shipping_length::after {
  content: "";
  height: 2px;
  width: 100%;
  color: #3a3830;
  position: absolute;
} */
.product-expand {
  z-index: 1;
  height: 212px;
  position: relative;
  overflow: hidden;
}
.drawing-switch {
  position: absolute;
  z-index: 20;
  right: 10px;
  bottom: 12px;
}
.switch .checkbox {
  position: relative;
  display: inline-block;
}
.switch .model-6 .checkbox input {
  left: -25%;
  top: -25%;
  right: -25%;
  bottom: -25%;
  max-width: inherit;
  width: 150%;
  height: 150%;
}
.switch .checkbox input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
}
.switch .model-6 .checkbox label {
  background: #cbc8c3;
  height: 2px;
  width: 30px;
}
.switch .checkbox label {
  width: 90px;
  height: 42px;
  background: #ccc;
  position: relative;
  display: inline-block;
  -webkit-border-radius: 46px;
  -moz-border-radius: 46px;
  border-radius: 46px;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  -ms-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
.switch .model-6 .checkbox label::before {
  content: "Tap for Dimensions";
  position: absolute;
  right: 40px;
  top: -7px;
  white-space: nowrap;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
}
.switch .model-6 .checkbox label::after {
  background: #3a3830;
  top: -6px;
  width: 14px;
  height: 14px;
}
.switch .checkbox label::after {
  content: "";
  position: absolute;
  width: 50px;
  height: 50px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  left: 0;
  top: -5px;
  z-index: 2;
  background: #fff;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  -ms-transform: 0 0 5px rgba(0, 0, 0, 0.2);
  -o-transform: 0 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  -ms-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
input[type="checkbox"] + label,
input[type="radio"] + label {
  font-weight: 400;
}
label[for] {
  cursor: pointer;
}
.switch .model-6 .checkbox input:checked + label::after {
  left: 16px;
}
.switch .checkbox input:checked + label::after {
  left: 40px;
}
.switch .model-6 .checkbox label::after {
  background: #3a3830;
  top: -6px;
  width: 14px;
  height: 14px;
}
.switch .model-6 .checkbox input:checked + label::before {
  content: "Tap for Image";
}
.block-variant-img {
  z-index: 10;
}
.block-variant-img {
  -webkit-transform: translateY(-10px);
  -moz-transform: translateY(-10px);
  -ms-transform: translateY(-10px);
  transform: translateY(-10px);
  min-height: 180px;
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -webkit-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
  -ms-transform: translateY(-5px);
  transform: translateY(-5px);
}
.block-variant-img > img {
  width: 100%;
}
.options--triple-range {
  display: flex;
  flex-wrap: wrap;
  column-gap: 33px;
}
/* .options--triple-range .half-width:last-of-type {
  margin-left: auto;
  margin-right: auto;
} */
.half-width {
  max-width: 43%;
  margin-top: 15px;
  width: 100%;
}
@media screen and (min-width: 769px) and (max-width: 840px) {
  .half-width {
    max-width: unset;
  }
}

.missing-image {
  font-size: 1.1em;
  margin-bottom: 1em;
  text-align: center;
}
.option-heading {
  text-align: left;
  margin-bottom: -10px;
  margin-top: 6px;
}
.option-heading:not(:first-of-type) {
  margin-top: 15px;
}
.active-select {
  background-color: #F0F0F0;
}
.pillow-copy {
  padding-bottom: 18px;
  font-size: 14px;
  opacity: 0.8;
}
.pillow-selector__container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: left;
}
.pillow-selector__select {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 2px;
  cursor: pointer;
  width: calc(50% - 3px);
  min-height: 60px;
  box-sizing: border-box;
}
.pillow-selector__select label {
  width: 100%;
  text-align: left;
  font-weight: 600 !important;
  line-height: 26px;
  font-size: 16px;
  color: #3a3830;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2px;
  gap: 6px;
}
.pillow-selector__select input {
  display: none;
}
.checkmark {
  height: 14px;
  width: 14px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  margin-left: 12px;
  flex-shrink: 0;
}
.checkmark::after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.2s ease-in-out;
  background: #3a3830;
  content: "";
  position: absolute;
  opacity: 0;
}
.checkmark.active::after {
  opacity: 1;
}
</style>
